import styled from '@emotion/styled';
import { Cloud as CloudIcon } from '@mui/icons-material';
import { blue } from '@mui/material/colors';

const OneDriveIcon = styled(CloudIcon)(({ theme }) => ({
  color: theme.isDark ? blue[300] : blue[700],
}));

export default OneDriveIcon;
